// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: simplified Microsoft Teams mark.

interface TeamsLogoProps {
	size?: number;
	style?: React.CSSProperties;
}

export function TeamsLogo({size = 16, style}: TeamsLogoProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 32 32"
			fill="none"
			aria-hidden="true"
			style={{flexShrink: 0, ...style}}
		>
			<circle cx="24.5" cy="9.5" r="3.5" fill="#7B83EB" />
			<path d="M19.5 14h9.2c.7 0 1.3.6 1.3 1.3v6.2a5.5 5.5 0 0 1-5.5 5.5H23a6.5 6.5 0 0 1-3.5-1V14z" fill="#5059C9" />
			<circle cx="14.5" cy="8" r="4.5" fill="#7B83EB" />
			<path d="M7 13h13.6c.8 0 1.4.6 1.4 1.4v8.1A7.5 7.5 0 0 1 14.5 30 7.5 7.5 0 0 1 7 22.5V13z" fill="#7B83EB" />
			<rect x="2" y="9" width="16" height="16" rx="2.2" fill="#4B53BC" />
			<path d="M6 13.4h8v2.1h-2.9V21H8.9v-5.5H6v-2.1z" fill="#fff" />
		</svg>
	);
}
